import { apiClient, handleResponse } from './axios';

async function queryByString(string) {
  try {
    const response = await apiClient.get(`/query/${string}`);
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    return error.response;
  }
}

const appointmentServices = {
  queryByString,
};

export default appointmentServices;
